module.exports = __webpack_public_path__ + "img/Coin.c345cfd5.png";